import { Link, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import moment from "moment";
import { useEffect } from "react";

const BlogDetailsPage = () => {
  const { id } = useParams();
  const baseUrl = process.env.REACT_APP_API_URL;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const {
    data: blog,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["blog", id],
    queryFn: async () => {
      const res = await axios.get(`${baseUrl}blog/${id}`);
      return res.data.data;
    },
    enabled: !!id, // only run if id exists
  });

  if (isLoading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "50vh" }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="text-center text-danger" style={{ minHeight: "50vh" }}>
        <h4>Something went wrong! 😞</h4>
      </div>
    );
  }

  return (
    <section className="bg-light">
      {/* Blog Hero */}
      <div className="blog-details-hero text-center py-5 mb-5">
        <div className="container">
          <h1 className="display-4 fw-bold text-white">{blog.title}</h1>
          <p className="lead text-white-50 mt-3">
            By {blog.author} | {moment(blog.date).format("MMMM D, YYYY")}
          </p>
        </div>
      </div>

      {/* Blog Content */}
      <div className="container pb-5">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="card shadow-sm border-0 rounded-4 p-4">
              <p className="text-muted mb-4" style={{ fontSize: "1.1rem" }}>
                {blog.excerpt}
              </p>

              {/* Dummy full content part */}
              <div style={{ lineHeight: "1.8", fontSize: "1.05rem" }}>
                {blog.content || "Full blog content will appear here..."}
              </div>

              <div className="mt-4">
                <Link
                  to="/blog"
                  className="btn btn-outline-primary rounded-pill"
                >
                  Back to Blogs
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Custom CSS */}
      <style>
        {`
          :root {
            --bs-primary: #0f4372;
          }

          .blog-details-hero {
            background: linear-gradient(rgba(15, 67, 114, 0.8), rgba(15, 67, 114, 0.8)),
              url('https://images.unsplash.com/photo-1507525428034-b723cf961d3e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1950&q=80');
            background-size: cover;
            background-position: center;
            border-radius: 0 0 30px 30px;
          }

          .card p {
            font-size: 1rem;
            color: #333;
          }
        `}
      </style>
    </section>
  );
};

export default BlogDetailsPage;
